export function safeRound(round: number, width: number, height: number): number {
  return Math.max(0, Math.min(round, Math.min(height, width) / 2))
}
